import { z } from 'zod';
import { trainingAssessmentOptionSchema, trainingCommandIdSchema, trainingContentKeySchema, trainingCourseIdSchema, trainingReleaseIdSchema, } from './training-content.contract.js';
export const trainingAssessmentsCapability = 'training.assessments.v1';
export const trainingGradesCapability = 'training.grades.v1';
export const trainingAttemptIdSchema = z.string().uuid();
export const trainingAssessmentPublicQuestionSchema = z.strictObject({
    key: trainingContentKeySchema,
    prompt: z.string(),
    options: z.array(trainingAssessmentOptionSchema),
});
export const trainingAssessmentQuestionSnapshotSchema = trainingAssessmentPublicQuestionSchema.extend({
    lessonKey: trainingContentKeySchema.nullable(),
    correctOptionKeys: z.array(trainingContentKeySchema).min(1),
    explanation: z.string(),
    citationKeys: z.array(trainingContentKeySchema),
});
export const trainingAssessmentSnapshotSchema = z.strictObject({
    title: z.string(),
    passingScoreBasisPoints: z.number().int().min(1).max(10_000),
    attemptsAllowed: z.number().int().min(1).max(20),
    questions: z.array(trainingAssessmentQuestionSnapshotSchema).min(1).max(100),
});
export const trainingAssessmentResponseItemSchema = z.strictObject({
    questionKey: trainingContentKeySchema,
    selectedOptionKeys: z.array(trainingContentKeySchema).max(10),
    timeSpentSeconds: z.number().int().min(0).max(14_400),
    changeCount: z.number().int().min(0).max(10_000),
});
export const trainingStartAssessmentSchema = z.strictObject({
    commandId: trainingCommandIdSchema,
    attemptId: trainingAttemptIdSchema,
    courseId: trainingCourseIdSchema,
    releaseId: trainingReleaseIdSchema,
});
export const trainingSubmitAssessmentSchema = z.strictObject({
    commandId: trainingCommandIdSchema,
    responses: z.array(trainingAssessmentResponseItemSchema).min(1).max(100),
});
export const trainingAssessmentAttemptSchema = z.strictObject({
    id: trainingAttemptIdSchema,
    tenantId: z.string().uuid(),
    membershipId: z.string().uuid(),
    courseId: trainingCourseIdSchema,
    releaseId: trainingReleaseIdSchema,
    attemptNumber: z.number().int().positive(),
    status: z.enum(['in-progress', 'submitted']),
    snapshotHash: z.string().regex(/^[a-f0-9]{64}$/),
    scoreBasisPoints: z.number().int().min(0).max(10_000).nullable(),
    passed: z.boolean().nullable(),
    startedAt: z.string().datetime({ offset: true }),
    submittedAt: z.string().datetime({ offset: true }).nullable(),
});
export const trainingAssessmentStartResponseSchema = z.strictObject({
    data: trainingAssessmentAttemptSchema.extend({
        title: z.string(),
        passingScoreBasisPoints: z.number().int().min(1).max(10_000),
        questions: z.array(trainingAssessmentPublicQuestionSchema),
    }),
    command: z.strictObject({ commandId: trainingCommandIdSchema, idempotent: z.boolean() }),
});
export const trainingAssessmentResultResponseSchema = z.strictObject({
    data: trainingAssessmentAttemptSchema.extend({
        scoreBasisPoints: z.number().int().min(0).max(10_000),
        passed: z.boolean(),
        totalQuestions: z.number().int().positive(),
        correctQuestions: z.number().int().min(0),
        internalCompletionNotice: z.string(),
    }),
    command: z.strictObject({ commandId: trainingCommandIdSchema, idempotent: z.boolean() }),
});
export const trainingGradeSchema = trainingAssessmentAttemptSchema.extend({
    courseTitle: z.string(),
    responseSnapshot: z.array(trainingAssessmentResponseItemSchema),
    questionSnapshot: z.array(trainingAssessmentQuestionSnapshotSchema),
});
export const trainingGradesQuerySchema = z.strictObject({
    scope: z.enum(['mine', 'all']).default('mine'),
    membershipId: z.string().uuid().nullable().default(null),
    courseId: trainingCourseIdSchema.nullable().default(null),
    limit: z.number().int().min(1).max(200).default(100),
    offset: z.number().int().min(0).default(0),
});
export const trainingGradesResponseSchema = z.strictObject({
    data: z.array(trainingGradeSchema),
    page: z.strictObject({
        limit: z.number().int().positive(), offset: z.number().int().nonnegative(),
        returned: z.number().int().nonnegative(), total: z.number().int().nonnegative(),
    }),
});
//# sourceMappingURL=training-assessment.contract.js.map